module.exports = __webpack_public_path__ + "img/1.eeec6f39.png";